import { render } from "./ModalInvoices.vue?vue&type=template&id=04274390"
import script from "./ModalInvoices.vue?vue&type=script&lang=js"
export * from "./ModalInvoices.vue?vue&type=script&lang=js"

import "./ModalInvoices.vue?vue&type=style&index=0&id=04274390&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__